<template>
  <div />
</template>

<script>

export default {
    // import引入的组件需要注入到对象中才能使用
    components: {

    },
    data() {
        return {
            process: process.env.VUE_APP_BASE_API
        }
    },
    computed: {

    },
    // 监控data中的数据变化
    watch: {

    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
        console.log(process.env.VUE_APP_BASE_API, 'process.env.VUE_APP_BASE_API')
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, // 生命周期 - 创建之前
    beforeMount() {}, // 生命周期 - 挂载之前
    beforeUpdate() {}, // 生命周期 - 更新之前
    updated() {}, // 生命周期 - 更新之后
    beforeDestroy() {}, // 生命周期 - 销毁之前
    destroyed() {}, // 生命周期 - 销毁完成
    activated() {},
    // 方法集合
    methods: {

    } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
// @import url(); 引入公共css类

</style>
